import { TableProps } from '@shared/Table'
import IMask from 'imask'
import { SalaryCardListExcelType } from 'store/types/salaryCard'
import { t } from 'i18next'
import { useWatch } from 'react-hook-form'
import {
  EmployeeStatusError,
  EmployeeStatusSuccess,
} from '@modules/CustomIcons'
import { Space, Tooltip } from 'antd'
import { InfoCircleOutlined } from '@ant-design/icons'

export const columns: () => TableProps<
  Omit<SalaryCardListExcelType, 'key'>
>['editColumns'] = () => ({
  id: {
    // ids
    title: '№',
    hasSorter: true,
    width: 40,
    fixed: 'left',
    render(value, record, index) {
      return value + 1
    },
  },
  customerInfo: {
    title: t('orders.salaryCardOrder.tableTitles.fullName'),
    width: 200,
    fixed: 'left',
    hasSearch: true,
    hasSorter: true,
    editable: true,
    ellipsis: true,
  },
  serialType: {
    title: t('orders.salaryCardOrder.tableTitles.identityCardSeries'),
    hasSelect: true,
    hasSorter: true,
    editable: true,
    ellipsis: true,
    width: 100,
    filterSelectOptions: [
      {
        label: 'Seçin',
        value: '',
      },
      {
        label: 'AA',
        value: 'AA',
      },
      {
        label: 'AB',
        value: 'AB',
      },
      {
        label: 'AZE',
        value: 'AZE',
      },
    ],
  },
  serialNo: {
    title: t('orders.salaryCardOrder.tableTitles.identityCardNumber'),
    hasSearch: true,
    hasSorter: true,
    editable: true,
    ellipsis: true,
    type: 'number',
    width: 100,
  },
  pin: {
    title: t('orders.salaryCardOrder.tableTitles.pin'),
    hasSearch: true,
    hasSorter: true,
    editable: true,
    width: 100,
    maskOptions: {
      mask: /^[A-Za-z0-9]{0,7}$/,
      options: { prepare: (str) => str.toUpperCase() },
    },
  },
  position: {
    title: t('orders.salaryCardOrder.tableTitles.position'),
    hasSearch: true,
    width: 100,
    editable: true,
  },
  salary: {
    title: t('orders.salaryCardOrder.tableTitles.monthlySalary'),
    hasSearch: true,
    hasSorter: true,
    editable: true,
    ellipsis: true,
    type: 'number',
    width: 100,
    maskOptions: {
      mask: Number,
      options: { signed: false, thousandsSeparator: ' ', scale: 0, min: 0 },
    },
  },
  phoneNumber: {
    title: t('orders.salaryCardOrder.tableTitles.phoneNumber'),
    hasSearch: true,
    type: 'number',
    editable: true,
    width: 120,
    maskOptions: {
      mask: '(##) 000-00-00',
      options: {
        blocks: {
          '##': {
            mask: IMask.MaskedEnum,
            enum: ['50', '51', '55', '70', '77', '90', '99', '10', '11'],
          },
        },
        definitions: {
          '0': /[0-9]/,
        },
        prepare: (str) => str.replace(/[^\d]/g, ''),
        commit: (value, masked) => {
          masked._value = value.replace(/\D/g, '')
        },
      },
    },
  },
  // code: {
  //   title: (<Space>
  //     {t('orders.salaryCardOrder.tableTitles.codeWord')}
  //     <Tooltip title={t('orders.codeWordTitle')}><InfoCircleOutlined style={{ cursor: 'pointer', color: '#015CD1' }} /></Tooltip>
  //   </Space>),
  //   editable: true,
  //   ellipsis: true,
  //   width: 100,
  //   maskOptions: {
  //     mask: /^[A-Za-z0-9]{0,30}$/,
  //     options: { maxLength: 30, prepare: (str) => str.toUpperCase() },
  //   },
  // },
  email: {
    title: t('orders.salaryCardOrder.tableTitles.emailAvailable'),
    textWrap: 'word-break',
    editable: true,
    ellipsis: true,
    width: 120,
    maskOptions: {
      mask: /^\S*@?\S*$/,
      options: {
        blocks: {
          username: {
            mask: /^[a-zA-Z0-9._%+-]+$/,
          },
          domain: {
            mask: /^[a-zA-Z0-9.-]+$/,
          },
          topLevelDomain: {
            mask: /^[a-zA-Z]{2,}$/,
          },
        },
        prepare: (str) => str.toLowerCase(),
      },
    },
  },
  // pdfTransactionId: {
  //   title: t('orders.salaryCardOrder.tableTitles.identitiyCopy'),
  //   textWrap: 'word-break',
  //   editable: true,
  //   isFile: true,
  //   width: 250,
  //   ellipsis: true
  // },
  status: {
    title: t('orders.salaryCardOrder.tableTitles.status'),
    i18nKeyForLabel: 'orders.salaryCardOrder.constants',
    width: 50,
    editable: false,
    hasSelect: true,
    align: 'center',
    render(value, _, index) {
      return value === 'valid' ? <EmployeeStatusSuccess /> : <EmployeeStatusError />
    },
  },
})

function FormRowStatus({ index }: { index: number }) {
  const value = useWatch({ name: `formStatus.${index}.value` })
  const centerStyle = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  }
  return (
    <div style={centerStyle}>
      {value === 'valid' ? <EmployeeStatusSuccess /> : <EmployeeStatusError />}
    </div>
  )
}
